<div class="toggle-container" [formGroup]="form">
  <div class="d-flex flex-column">
    <p class="text-header-blue"><b rtI18n>Direct Messages</b></p>
    <div class="toggle-item">
      <mat-slide-toggle formControlName="directMessageEmail"></mat-slide-toggle>
      <p class="label" rtI18n>Email</p>
    </div>
    <div class="toggle-item">
      <mat-slide-toggle formControlName="directMessageText"></mat-slide-toggle>
      <p class="label" rtI18n>Text</p>
    </div>
    <div class="toggle-item"
         matTooltip="Receiving push notifications requires a mobile device. Edit this in your device's app settings."
         matTooltipTouchGestures="on">
      <mat-slide-toggle formControlName="directMessagePush"></mat-slide-toggle>
      <p class="label" rtI18n>Push</p>
      @if (!systemPushPermissionGranted && isNativePlatform) {
        <a href="javascript:void(0);" (click)="openAppSettings()" class="ms-2" rtI18n>App Settings</a>
      }
    </div>
    <div class="toggle-item">
      <mat-slide-toggle formControlName="directMessageToast"></mat-slide-toggle>
      <p class="label">
        <span rtI18n>Banner</span>
        <i class="icon-info icon-text-blue"
           style="cursor: help"
           matTooltip="This is a small popup on screen when you recieve a direct message while using the app."
           matTooltipTouchGestures="on"
           #bannerTooltip="matTooltip"
           (click)="bannerTooltip.toggle()"></i>
      </p>
    </div>
  </div>
  <div class="d-flex flex-column">
    <p class="text-header-blue"><b rtI18n>Posts</b></p>
    <div class="toggle-item">
      <mat-slide-toggle formControlName="postEmail"></mat-slide-toggle>
      <p class="label" rtI18n>Email</p>
    </div>
    <div class="toggle-item">
      <mat-slide-toggle formControlName="postText"></mat-slide-toggle>
      <p class="label" rtI18n>Text</p>
    </div>
    <div class="toggle-item"
         matTooltip="Receiving push notifications requires a mobile device. Edit this in your device's app settings."
         matTooltipTouchGestures="on">
      <mat-slide-toggle formControlName="postPush"></mat-slide-toggle>
      <p class="label" rtI18n>Push</p>
      @if (!systemPushPermissionGranted && isNativePlatform) {
        <a href="javascript:void(0);" (click)="openAppSettings()" class="ms-2" rtI18n>App Settings</a>
      }
    </div>
    <div class="toggle-item">
      <mat-slide-toggle formControlName="postPhone"></mat-slide-toggle>
      <p class="label">
        <span rtI18n>Phone</span>
        <i class="icon-info icon-text-blue"
           style="cursor: help"
           matTooltip="Some posts include an automated phone call. Turn this off to skip those calls; Critical Alert calls are controlled separately."
           matTooltipTouchGestures="on"
           #postPhoneTooltip="matTooltip"
           (click)="postPhoneTooltip.toggle()"></i>
      </p>
    </div>
  </div>
  <div class="d-flex flex-column">
    <p class="text-header-blue"><b rtI18n>Critical Alerts</b></p>
    <div class="toggle-item">
      <mat-slide-toggle formControlName="criticalAlertPhone"></mat-slide-toggle>
      <p class="label" rtI18n>Phone</p>
    </div>
    <div class="d-flex align-items-center gap-2">
      <i class="icon-info icon-text-blue" style="width: 16px; height: 16px; flex-shrink: 0;"></i>
      <div class="text-text-blue" style="font-size: 12px">
        <i rtI18n>
          You will still receive email and text notifications for Critical Alerts even if Phone is disabled.
        </i>
      </div>
    </div>
  </div>
</div>
